<div class="edit-interactive">
    <div class="exit">
        <button type="button" routerLink="../..">
            <span class="icon-anchor-top"></span>
            <span>Exit</span>
        </button>
    </div>

    @if (interactive(); as interactive) {
        @let displayState = interactive | interactiveDisplayState;
        <div class="edit-heading">
            <h3 class="edit-title">Edit {{ interactive.name }}</h3>
            <tools-badge [key]="displayState" [library]="badgeLibrary">
                {{ displayState }}
            </tools-badge>
        </div>

        <app-interactive-form
            [initialValue]="formValue()"
            [currentState]="displayState"
            [availableTargetStates]="availableTargetStates()"
            [isSubmitting]="submitting()"
            (formSubmit)="onSubmit($event)"
        ></app-interactive-form>
    } @else {
        <div class="loading"></div>
    }
</div>
